import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import { SmoothScroll } from "@/components/Motion";
import HomePage from "@/pages/HomePage";
import { WealthPage, SolutionsPage, AboutPage } from "@/pages/ServicePages";
import InsightsPage from "@/pages/InsightsPage";
import ArticlePage from "@/pages/ArticlePage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";
import AdminPage from "@/pages/AdminPage";
import NotFoundPage from "@/pages/NotFoundPage";
import SitemapPage from "@/pages/SitemapPage";


export default function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/wealth-management" element={<WealthPage />} />
          <Route path="/investment-solutions" element={<SolutionsPage />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/insights/:slug" element={<ArticlePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<LegalPage type="privacy" />} />
          <Route path="/terms-of-use" element={<LegalPage type="terms" />} />
          <Route path="/investment-disclaimer" element={<LegalPage type="disclaimer" />} />
          <Route path="/risk-disclosures" element={<LegalPage type="risk" />} />
          <Route path="/sitemap" element={<SitemapPage />} />
        </Route>
        <Route path="/editor/*" element={<AdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}